import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { supabase } from "../../api/supabase/client";
import { globalStores } from "../../api/globalStores";
import { observer } from "mobx-react";

const PostHogAuthHandler = observer(() => {
  const posthog = usePostHog();
  const { parentStore, teacherStore, childStore } = globalStores;

  useEffect(() => {
    let distinctId = "";
    const properties: Record<string, any> = {};

    if (teacherStore.teacherAccount?.id) {
      distinctId = `teacher_${teacherStore.teacherAccount.id}`;
      properties.role = "teacher";
      if (teacherStore.staffDetail?.isAdmin) {
        properties.is_admin = true;
      }
    } else if (parentStore.parentAccount?.id) {
      if (childStore.childAccount?.id) {
        distinctId = `parent_${parentStore.parentAccount.id}_child_${childStore.childAccount.id}`;
        properties.role = "student";
      } else {
        distinctId = `parent_${parentStore.parentAccount.id}`;
        properties.role = "parent";
      }
    }

    if (distinctId) {
      posthog.identify(distinctId, properties);
    } else {
      // If we had a session but now we don't, we might want to reset.
      // However, onAuthStateChange below handles the explicit logout.
    }
  }, [
    posthog,
    parentStore.parentAccount?.id,
    teacherStore.teacherAccount?.id,
    childStore.childAccount?.id,
    teacherStore.staffDetail?.isAdmin,
  ]);

  useEffect(() => {
    // Listen for auth state changes (mainly for logout)
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event) => {
      if (event === "SIGNED_OUT") {
        posthog.reset();
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [posthog]);

  return null;
});

export default PostHogAuthHandler;
